import { useAuth } from '@clerk/clerk-react';
import { Navigate, Outlet } from 'react-router';

export const RequireAuthLayout = () => {
  const { isLoaded, userId } = useAuth();
  if (!isLoaded) return null;
  if (!userId) return <Navigate to="/sign-in" />;
  return <Outlet />;
};
